export const PERSONAL_LOAN_HEADER_TEXT = 'Find your personal loan'
